import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Demo data for development
const DEMO_TRANSACTIONS = [
  { id: '1', description: 'Salario', amount: 3500, type: 'income', category: 'salary', date: '2026-02-01', linkedTo: '2' },
  { id: '2', description: 'Renta', amount: 1200, type: 'expense', category: 'housing', date: '2026-02-01', linkedTo: '1' },
  { id: '3', description: 'Supermercado', amount: 85.50, type: 'expense', category: 'food', date: '2026-02-03' },
  { id: '4', description: 'Netflix', amount: 15.99, type: 'expense', category: 'entertainment', date: '2026-02-05' },
  { id: '5', description: 'Uber', amount: 12.00, type: 'expense', category: 'transport', date: '2026-02-06' },
  { id: '6', description: 'Freelance diseño', amount: 800, type: 'income', category: 'freelance', date: '2026-02-10' },
  { id: '7', description: 'Restaurante', amount: 45.00, type: 'expense', category: 'food', date: '2026-02-12' },
  { id: '8', description: 'Farmacia', amount: 32.00, type: 'expense', category: 'health', date: '2026-02-14' },
  { id: '9', description: 'Gasolina', amount: 55.00, type: 'expense', category: 'transport', date: '2026-02-15' },
  { id: '10', description: 'Curso online', amount: 29.99, type: 'expense', category: 'education', date: '2026-02-16' },
  { id: '11', description: 'Arriendo cobrado', amount: 850000, type: 'income', category: 'other', date: '2026-02-01', linkedTo: '12' },
  { id: '12', description: 'Crédito hipotecario', amount: 650000, type: 'expense', category: 'housing', date: '2026-02-05', linkedTo: '11' },
];

const DEMO_BUDGETS = [
  { id: '1', category: 'food', limit: 400, spent: 130.50 },
  { id: '2', category: 'transport', limit: 150, spent: 67.00 },
  { id: '3', category: 'entertainment', limit: 100, spent: 15.99 },
  { id: '4', category: 'housing', limit: 1200, spent: 1200 },
  { id: '5', category: 'health', limit: 100, spent: 32.00 },
];

const DEMO_GOALS = [
  { id: '1', name: 'Fondo de emergencia', target: 5000, saved: 2350, icon: '🛡️' },
  { id: '2', name: 'Vacaciones', target: 2000, saved: 800, icon: '✈️' },
  { id: '3', name: 'Laptop nueva', target: 1500, saved: 1500, icon: '💻' },
];

const DEMO_SPLITS = [
  { id: '1', description: 'Cena restaurante', amount: 65, myShare: 35, partnerShare: 30, date: '2026-02-14' },
  { id: '2', description: 'Supermercado', amount: 120, myShare: 60, partnerShare: 60, date: '2026-02-10' },
  { id: '3', description: 'Netflix + Spotify', amount: 28, myShare: 14, partnerShare: 14, date: '2026-02-01' },
];

const DEMO_BANKS = [
  { id: '1', name: 'BBVA', color: '#004481' },
  { id: '2', name: 'Santander', color: '#ec0000' },
];

const DEMO_CREDITS = [
  { id: '1', bankId: '1', type: 'card_installment', description: 'TV Samsung',
    totalAmount: 1200, installmentAmount: 100, totalInstallments: 12,
    paidInstallments: 5, startDate: '2025-09-01', category: 'shopping' },
  { id: '2', bankId: '2', type: 'loan', description: 'Préstamo personal',
    totalAmount: 5000, installmentAmount: 250, totalInstallments: 24,
    paidInstallments: 8, startDate: '2025-06-01', category: 'other' },
];

const currentMonth = () => new Date().toISOString().slice(0, 7);

const DEMO_INCOME_UNITS = [
  {
    id: '1', name: 'Negocio USA', grossIncome: 3000, currency: 'USD',
    fixedCosts: [
      { id: 'f1', name: 'Impuestos', amount: 450 },
      { id: 'f2', name: 'Hosting + tools', amount: 150 },
    ],
    memberIds: [], color: '#3b82f6', icon: '🇺🇸',
    recurrence: 'monthly', month: '2026-02',
  },
  {
    id: '2', name: 'Arriendo depto', grossIncome: 850000, currency: 'CLP',
    fixedCosts: [
      { id: 'f3', name: 'Contribuciones', amount: 85000 },
    ],
    memberIds: [], color: '#f59e0b', icon: '🏠',
    recurrence: 'monthly', month: '2026-02',
  },
];

const DEMO_BUSINESSES = [
  { id: '1', name: 'Giraffos', icon: '🦒', color: '#f59e0b', description: 'Consultora digital', currency: 'USD' },
];

const DEMO_PROJECTS = [
  {
    id: 'p1', businessId: '1', name: 'Website Acme', client: 'Acme Corp',
    description: 'Rediseño completo del sitio web', icon: '🌐', color: '#3b82f6',
    status: 'active', startDate: '2026-01-15', endDate: '2026-04-30', budget: 5000,
    milestones: [
      { id: 'm1', projectId: 'p1', name: 'Diseño aprobado', amount: 1500, dueDate: '2026-02-15', paid: true },
      { id: 'm2', projectId: 'p1', name: 'Desarrollo fase 1', amount: 2000, dueDate: '2026-03-15', paid: false },
      { id: 'm3', projectId: 'p1', name: 'Entrega final', amount: 1500, dueDate: '2026-04-30', paid: false },
    ],
  },
  {
    id: 'p2', businessId: '1', name: 'App FinTech', client: 'StartupXYZ',
    description: 'MVP de aplicación financiera', icon: '📱', color: '#10b981',
    status: 'active', startDate: '2026-02-01', endDate: '2026-06-30', budget: 12000,
    milestones: [
      { id: 'm4', projectId: 'p2', name: 'Prototipo', amount: 3000, dueDate: '2026-03-01', paid: false },
      { id: 'm5', projectId: 'p2', name: 'Beta', amount: 5000, dueDate: '2026-05-01', paid: false },
      { id: 'm6', projectId: 'p2', name: 'Launch', amount: 4000, dueDate: '2026-06-30', paid: false },
    ],
  },
];

const DEMO_PROPERTIES = [
  {
    id: 'prop1', name: 'Depto Las Condes', address: 'Av. Apoquindo 3200, Las Condes',
    icon: '🏢', color: '#8b5cf6', creditId: '2', rentAmount: 850000,
    tenantName: 'María González', tenantContact: '+56 9 8765 4321',
    status: 'rented',
  },
];

const DEMO_TENANT_EXPENSES = [
  { id: 'te1', propertyId: 'prop1', month: '2026-02', type: 'electricity', paid: true, amount: 45000 },
  { id: 'te2', propertyId: 'prop1', month: '2026-02', type: 'water', paid: true, amount: 22000 },
  { id: 'te3', propertyId: 'prop1', month: '2026-02', type: 'common', paid: false, amount: 65000 },
];

const DEMO_PERSONAL_PROJECTS = [
  {
    id: 'pp1', name: 'Hacer piscina', description: 'Piscina 4x8m en el patio trasero',
    icon: '🏊', color: '#3b82f6', status: 'active', budget: 5000000, deadline: '2026-06-30',
    items: [
      { id: 'pi1', name: 'Excavación', estimatedCost: 1500000, completed: false },
      { id: 'pi2', name: 'Materiales', estimatedCost: 2000000, completed: false },
      { id: 'pi3', name: 'Mano de obra', estimatedCost: 1200000, completed: false },
    ],
  },
  {
    id: 'pp2', name: 'Hacer quincho', description: 'Quincho con parrilla y barra',
    icon: '🔥', color: '#f59e0b', status: 'active', budget: 3000000, deadline: '2026-09-30',
    items: [
      { id: 'pi4', name: 'Construcción base', estimatedCost: 800000, completed: true },
      { id: 'pi5', name: 'Parrilla e instalación', estimatedCost: 600000, completed: false },
      { id: 'pi6', name: 'Muebles y terminaciones', estimatedCost: 400000, completed: false },
    ],
  },
  {
    id: 'pp3', name: 'Remodelación cocina', description: 'Cambio de muebles y encimera',
    icon: '🍳', color: '#10b981', status: 'completed', budget: 2500000, deadline: '2026-01-31',
    items: [
      { id: 'pi7', name: 'Muebles nuevos', estimatedCost: 1200000, completed: true },
      { id: 'pi8', name: 'Encimera granito', estimatedCost: 800000, completed: true },
      { id: 'pi9', name: 'Instalación', estimatedCost: 500000, completed: true },
    ],
  },
];

const DEMO_AGENDA = [
  { id: 'a1', title: 'Arriendo', amount: 1200, type: 'expense', category: 'housing', date: '2026-02-01', recurrence: 'monthly', icon: '🏠', color: '#8b5cf6', notes: '', paid: true, transactionId: '2' },
  { id: 'a2', title: 'Salario', amount: 3500, type: 'income', category: 'salary', date: '2026-02-01', recurrence: 'monthly', icon: '💰', color: '#22c55e', notes: '', paid: true, transactionId: '1' },
  { id: 'a3', title: 'Netflix', amount: 15.99, type: 'expense', category: 'entertainment', date: '2026-02-05', recurrence: 'monthly', icon: '🎬', color: '#ec4899', notes: '', paid: false, transactionId: null },
];

const DEMO_MEMBERS = [
  { id: '1', name: 'Francisco', relationship: 'yo', initials: 'FR', color: '#3b82f6', emoji: '😎' },
  { id: '2', name: 'Ana', relationship: 'pareja', initials: 'AN', color: '#ec4899', emoji: '🥰' },
];

const DEMO_USER = {
  name: 'Francisco',
  email: 'francisco@giraffos.com',
  plan: 'Pro',
  initials: 'FR',
  currency: 'CLP',
};

export const useStore = create(
  persist(
    (set) => ({
      // Sync flag: set to true when applying remote data to prevent sync loops
      _fromRemote: false,

      // User
      user: DEMO_USER,
      updateUser: (data) =>
        set((s) => ({ user: { ...s.user, ...data } })),

      // Transactions
      transactions: DEMO_TRANSACTIONS,
      addTransaction: (tx) =>
        set((s) => {
          const newTx = { ...tx, id: crypto.randomUUID() };
          let budgets = s.budgets;
          const newToasts = [];

          // Auto-update budget spent if this is an expense with a matching budget
          if (tx.type === 'expense') {
            budgets = budgets.map((b) => {
              if (b.category !== tx.category) return b;
              const newSpent = b.spent + tx.amount;
              const prevPct = (b.spent / b.limit) * 100;
              const newPct = (newSpent / b.limit) * 100;
              // Budget threshold notifications
              if (prevPct < 100 && newPct >= 100) {
                newToasts.push({ type: 'error', message: `budget.exceeded.${b.category}` });
              } else if (prevPct < 80 && newPct >= 80) {
                newToasts.push({ type: 'warning', message: `budget.warning.${b.category}` });
              }
              return { ...b, spent: newSpent };
            });
          }

          return {
            transactions: [newTx, ...s.transactions],
            budgets,
            toasts: [...s.toasts, ...newToasts.map((t) => ({ ...t, id: crypto.randomUUID() }))],
          };
        }),
      removeTransaction: (id) =>
        set((s) => {
          const tx = s.transactions.find((t) => t.id === id);
          let budgets = s.budgets;
          // Reverse budget.spent if removing an expense
          if (tx && tx.type === 'expense') {
            budgets = budgets.map((b) =>
              b.category === tx.category
                ? { ...b, spent: Math.max(0, b.spent - tx.amount) }
                : b
            );
          }
          return {
            transactions: s.transactions
              .filter((t) => t.id !== id)
              .map((t) => (t.linkedTo === id ? { ...t, linkedTo: undefined } : t)),
            budgets,
          };
        }),
      updateTransaction: (id, data) =>
        set((s) => {
          const tx = s.transactions.find((t) => t.id === id);
          if (!tx) return s;
          let budgets = s.budgets;
          // If category changed on an expense, move budget spent
          if (data.category && data.category !== tx.category && tx.type === 'expense') {
            budgets = budgets.map((b) => {
              if (b.category === tx.category) return { ...b, spent: Math.max(0, b.spent - tx.amount) };
              if (b.category === data.category) return { ...b, spent: b.spent + tx.amount };
              return b;
            });
          }
          return {
            transactions: s.transactions.map((t) => (t.id === id ? { ...t, ...data } : t)),
            budgets,
          };
        }),
      bulkUpdateTransactions: (ids, data) =>
        set((s) => {
          let budgets = s.budgets;
          const transactions = s.transactions.map((tx) => {
            if (!ids.includes(tx.id)) return tx;
            // Move budget spent if category changed on expense
            if (data.category && data.category !== tx.category && tx.type === 'expense') {
              budgets = budgets.map((b) => {
                if (b.category === tx.category) return { ...b, spent: Math.max(0, b.spent - tx.amount) };
                if (b.category === data.category) return { ...b, spent: b.spent + tx.amount };
                return b;
              });
            }
            return { ...tx, ...data };
          });
          return { transactions, budgets };
        }),
      bulkRemoveTransactions: (ids) =>
        set((s) => {
          const idsSet = new Set(ids);
          let budgets = s.budgets;
          s.transactions.forEach((tx) => {
            if (!idsSet.has(tx.id)) return;
            if (tx.type === 'expense') {
              budgets = budgets.map((b) =>
                b.category === tx.category
                  ? { ...b, spent: Math.max(0, b.spent - tx.amount) }
                  : b
              );
            }
          });
          return {
            transactions: s.transactions.filter((t) => !idsSet.has(t.id)),
            budgets,
          };
        }),

      // Link / unlink transactions
      linkTransactions: (id1, id2) =>
        set((s) => {
          const tx1 = s.transactions.find((t) => t.id === id1);
          const tx2 = s.transactions.find((t) => t.id === id2);
          if (!tx1 || !tx2 || tx1.type === tx2.type) return s;
          return {
            transactions: s.transactions.map((t) => {
              if (t.id === id1) return { ...t, linkedTo: id2 };
              if (t.id === id2) return { ...t, linkedTo: id1 };
              return t;
            }),
          };
        }),
      unlinkTransaction: (id) =>
        set((s) => {
          const tx = s.transactions.find((t) => t.id === id);
          if (!tx || !tx.linkedTo) return s;
          const partnerId = tx.linkedTo;
          return {
            transactions: s.transactions.map((t) => {
              if (t.id === id || t.id === partnerId) {
                const { linkedTo, ...rest } = t;
                return rest;
              }
              return t;
            }),
          };
        }),

      // Budgets
      budgets: DEMO_BUDGETS,
      addBudget: (budget) =>
        set((s) => ({
          budgets: [...s.budgets, { ...budget, id: crypto.randomUUID() }],
        })),
      updateBudget: (id, data) =>
        set((s) => ({
          budgets: s.budgets.map((b) => (b.id === id ? { ...b, ...data } : b)),
        })),
      removeBudget: (id) =>
        set((s) => ({
          budgets: s.budgets.filter((b) => b.id !== id),
        })),

      // Goals
      goals: DEMO_GOALS,
      addGoal: (goal) =>
        set((s) => ({
          goals: [...s.goals, { ...goal, id: crypto.randomUUID() }],
        })),
      updateGoal: (id, data) =>
        set((s) => ({
          goals: s.goals.map((g) => (g.id === id ? { ...g, ...data } : g)),
        })),
      removeGoal: (id) =>
        set((s) => ({
          goals: s.goals.filter((g) => g.id !== id),
        })),
      addFundsToGoal: (id, amount) =>
        set((s) => ({
          goals: s.goals.map((g) =>
            g.id === id ? { ...g, saved: Math.min(g.saved + amount, g.target) } : g
          ),
        })),
      duplicateGoal: (id) =>
        set((s) => {
          const goal = s.goals.find((g) => g.id === id);
          if (!goal) return s;
          return {
            goals: [...s.goals, { ...goal, id: crypto.randomUUID(), name: `${goal.name} (copia)`, saved: 0 }],
          };
        }),

      // Couple
      coupleCode: null,
      partner: null,
      isCoupled: false,
      generateCoupleCode: () =>
        set(() => ({
          coupleCode: String(Math.floor(100000 + Math.random() * 900000)),
        })),
      connectPartner: (code) =>
        set(() => ({
          isCoupled: true,
          partner: { name: 'Pareja', code },
        })),
      disconnectPartner: () =>
        set(() => ({
          isCoupled: false,
          partner: null,
          coupleCode: null,
        })),

      // Splits
      splits: DEMO_SPLITS,
      addSplit: (split) =>
        set((s) => ({
          splits: [{ ...split, id: crypto.randomUUID() }, ...s.splits],
        })),
      removeSplit: (id) =>
        set((s) => ({
          splits: s.splits.filter((sp) => sp.id !== id),
        })),

      // Banks
      banks: DEMO_BANKS,
      addBank: (bank) =>
        set((s) => ({
          banks: [...s.banks, { ...bank, id: crypto.randomUUID() }],
        })),
      updateBank: (id, data) =>
        set((s) => ({
          banks: s.banks.map((b) => (b.id === id ? { ...b, ...data } : b)),
        })),
      removeBank: (id) =>
        set((s) => ({
          banks: s.banks.filter((b) => b.id !== id),
          credits: s.credits.filter((c) => c.bankId !== id),
        })),
      duplicateBank: (id) =>
        set((s) => {
          const bank = s.banks.find((b) => b.id === id);
          if (!bank) return s;
          const { id: _, ...rest } = bank;
          return { banks: [...s.banks, { ...rest, name: `${rest.name} (copia)`, id: crypto.randomUUID() }] };
        }),

      // Credits
      credits: DEMO_CREDITS,
      addCredit: (credit) =>
        set((s) => ({
          credits: [...s.credits, { ...credit, id: crypto.randomUUID() }],
        })),
      updateCredit: (id, data) =>
        set((s) => ({
          credits: s.credits.map((c) => (c.id === id ? { ...c, ...data } : c)),
        })),
      removeCredit: (id) =>
        set((s) => ({
          credits: s.credits.filter((c) => c.id !== id),
        })),
      duplicateCredit: (id) =>
        set((s) => {
          const credit = s.credits.find((c) => c.id === id);
          if (!credit) return s;
          const { id: _, ...rest } = credit;
          return { credits: [...s.credits, { ...rest, description: `${rest.description} (copia)`, paidInstallments: 0, id: crypto.randomUUID() }] };
        }),
      payInstallment: (creditId, createTransaction = false) =>
        set((s) => {
          const credit = s.credits.find((c) => c.id === creditId);
          if (!credit || credit.paidInstallments >= credit.totalInstallments) return s;

          const credits = s.credits.map((c) =>
            c.id === creditId ? { ...c, paidInstallments: c.paidInstallments + 1 } : c
          );

          let transactions = s.transactions;
          let budgets = s.budgets;
          const newToasts = [];

          if (createTransaction) {
            const newTx = {
              id: crypto.randomUUID(),
              description: `${credit.description} (${credit.paidInstallments + 1}/${credit.totalInstallments})`,
              amount: credit.installmentAmount,
              type: 'expense',
              category: 'credit',
              date: new Date().toISOString().split('T')[0],
            };
            transactions = [newTx, ...transactions];

            // Update matching budget
            budgets = budgets.map((b) => {
              if (b.category !== 'credit') return b;
              const newSpent = b.spent + credit.installmentAmount;
              const prevPct = (b.spent / b.limit) * 100;
              const newPct = (newSpent / b.limit) * 100;
              if (prevPct < 100 && newPct >= 100) {
                newToasts.push({ type: 'error', message: `budget.exceeded.credit` });
              } else if (prevPct < 80 && newPct >= 80) {
                newToasts.push({ type: 'warning', message: `budget.warning.credit` });
              }
              return { ...b, spent: newSpent };
            });
          }

          return {
            credits,
            transactions,
            budgets,
            toasts: [...s.toasts, ...newToasts.map((t) => ({ ...t, id: crypto.randomUUID() }))],
          };
        }),

      // Members
      members: DEMO_MEMBERS,
      addMember: (member) =>
        set((s) => ({
          members: [...s.members, { ...member, id: crypto.randomUUID() }],
        })),
      updateMember: (id, data) =>
        set((s) => ({
          members: s.members.map((m) => (m.id === id ? { ...m, ...data } : m)),
        })),
      removeMember: (id) =>
        set((s) => ({
          members: s.members.filter((m) => m.id !== id),
        })),

      // Income Units
      incomeUnits: DEMO_INCOME_UNITS,
      addIncomeUnit: (unit) =>
        set((s) => ({
          incomeUnits: [...s.incomeUnits, { ...unit, id: crypto.randomUUID() }],
        })),
      updateIncomeUnit: (id, data) =>
        set((s) => ({
          incomeUnits: s.incomeUnits.map((u) => (u.id === id ? { ...u, ...data } : u)),
        })),
      removeIncomeUnit: (id) =>
        set((s) => ({
          incomeUnits: s.incomeUnits.filter((u) => u.id !== id),
          transactions: s.transactions.map((t) =>
            t.unitId === id ? { ...t, unitId: undefined } : t
          ),
        })),
      addFixedCost: (unitId, cost) =>
        set((s) => ({
          incomeUnits: s.incomeUnits.map((u) =>
            u.id === unitId
              ? { ...u, fixedCosts: [...u.fixedCosts, { ...cost, id: crypto.randomUUID() }] }
              : u
          ),
        })),
      removeFixedCost: (unitId, costId) =>
        set((s) => ({
          incomeUnits: s.incomeUnits.map((u) =>
            u.id === unitId
              ? { ...u, fixedCosts: u.fixedCosts.filter((c) => c.id !== costId) }
              : u
          ),
        })),
      duplicateIncomeUnit: (unitId, targetMonth) =>
        set((s) => {
          const unit = s.incomeUnits.find((u) => u.id === unitId);
          if (!unit) return s;
          const newUnit = {
            ...unit,
            id: crypto.randomUUID(),
            month: targetMonth || currentMonth(),
            fixedCosts: unit.fixedCosts.map((c) => ({ ...c, id: crypto.randomUUID() })),
          };
          return { incomeUnits: [...s.incomeUnits, newUnit] };
        }),

      // Businesses
      businesses: DEMO_BUSINESSES,
      addBusiness: (business) =>
        set((s) => ({
          businesses: [...s.businesses, { ...business, id: crypto.randomUUID() }],
        })),
      updateBusiness: (id, data) =>
        set((s) => ({
          businesses: s.businesses.map((b) => (b.id === id ? { ...b, ...data } : b)),
        })),
      removeBusiness: (id) =>
        set((s) => ({
          businesses: s.businesses.filter((b) => b.id !== id),
          projects: s.projects.filter((p) => p.businessId !== id),
          transactions: s.transactions.map((t) =>
            t.businessId === id ? { ...t, businessId: undefined, projectId: undefined } : t
          ),
        })),
      duplicateBusiness: (id) =>
        set((s) => {
          const biz = s.businesses.find((b) => b.id === id);
          if (!biz) return s;
          return {
            businesses: [...s.businesses, { ...biz, id: crypto.randomUUID(), name: `${biz.name} (copia)` }],
          };
        }),

      // Projects
      projects: DEMO_PROJECTS,
      addProject: (project) =>
        set((s) => {
          const id = crypto.randomUUID();
          const milestones = (project.milestones || []).map((m) => ({
            ...m,
            id: crypto.randomUUID(),
            projectId: id,
          }));
          return {
            projects: [...s.projects, { ...project, id, milestones }],
          };
        }),
      updateProject: (id, data) =>
        set((s) => ({
          projects: s.projects.map((p) => (p.id === id ? { ...p, ...data } : p)),
        })),
      removeProject: (id) =>
        set((s) => ({
          projects: s.projects.filter((p) => p.id !== id),
          transactions: s.transactions.map((t) =>
            t.projectId === id ? { ...t, projectId: undefined } : t
          ),
        })),
      addMilestone: (projectId, milestone) =>
        set((s) => ({
          projects: s.projects.map((p) =>
            p.id === projectId
              ? { ...p, milestones: [...p.milestones, { ...milestone, id: crypto.randomUUID(), projectId }] }
              : p
          ),
        })),
      updateMilestone: (projectId, milestoneId, data) =>
        set((s) => ({
          projects: s.projects.map((p) =>
            p.id === projectId
              ? { ...p, milestones: p.milestones.map((m) => (m.id === milestoneId ? { ...m, ...data } : m)) }
              : p
          ),
        })),
      removeMilestone: (projectId, milestoneId) =>
        set((s) => ({
          projects: s.projects.map((p) =>
            p.id === projectId
              ? { ...p, milestones: p.milestones.filter((m) => m.id !== milestoneId) }
              : p
          ),
        })),

      // Properties
      properties: DEMO_PROPERTIES,
      addProperty: (property) =>
        set((s) => ({
          properties: [...s.properties, { ...property, id: crypto.randomUUID() }],
        })),
      updateProperty: (id, data) =>
        set((s) => ({
          properties: s.properties.map((p) => (p.id === id ? { ...p, ...data } : p)),
        })),
      removeProperty: (id) =>
        set((s) => ({
          properties: s.properties.filter((p) => p.id !== id),
          transactions: s.transactions.map((t) =>
            t.propertyId === id ? { ...t, propertyId: undefined } : t
          ),
          tenantExpenses: s.tenantExpenses.filter((te) => te.propertyId !== id),
        })),
      duplicateProperty: (id) =>
        set((s) => {
          const prop = s.properties.find((p) => p.id === id);
          if (!prop) return s;
          return {
            properties: [...s.properties, { ...prop, id: crypto.randomUUID(), name: `${prop.name} (copia)` }],
          };
        }),

      // Tenant expenses (per property per month tracking)
      tenantExpenses: DEMO_TENANT_EXPENSES,
      setTenantExpense: (propertyId, month, type, data) =>
        set((s) => {
          const existing = s.tenantExpenses.find(
            (te) => te.propertyId === propertyId && te.month === month && te.type === type
          );
          if (existing) {
            return {
              tenantExpenses: s.tenantExpenses.map((te) =>
                te.id === existing.id ? { ...te, ...data } : te
              ),
            };
          }
          return {
            tenantExpenses: [
              ...s.tenantExpenses,
              { id: crypto.randomUUID(), propertyId, month, type, paid: false, amount: 0, ...data },
            ],
          };
        }),
      removeTenantExpense: (id) =>
        set((s) => ({
          tenantExpenses: s.tenantExpenses.filter((te) => te.id !== id),
        })),

      // Personal Projects
      personalProjects: DEMO_PERSONAL_PROJECTS,
      addPersonalProject: (project) =>
        set((s) => {
          const id = crypto.randomUUID();
          const items = (project.items || []).map((item) => ({
            ...item,
            id: crypto.randomUUID(),
          }));
          return { personalProjects: [...s.personalProjects, { ...project, id, items }] };
        }),
      updatePersonalProject: (id, data) =>
        set((s) => ({
          personalProjects: s.personalProjects.map((p) => (p.id === id ? { ...p, ...data } : p)),
        })),
      removePersonalProject: (id) =>
        set((s) => ({
          personalProjects: s.personalProjects.filter((p) => p.id !== id),
          transactions: s.transactions.map((t) =>
            t.personalProjectId === id ? { ...t, personalProjectId: undefined } : t
          ),
        })),
      addPersonalProjectItem: (projectId, item) =>
        set((s) => ({
          personalProjects: s.personalProjects.map((p) =>
            p.id === projectId
              ? { ...p, items: [...p.items, { ...item, id: crypto.randomUUID() }] }
              : p
          ),
        })),
      updatePersonalProjectItem: (projectId, itemId, data) =>
        set((s) => ({
          personalProjects: s.personalProjects.map((p) =>
            p.id === projectId
              ? { ...p, items: p.items.map((i) => (i.id === itemId ? { ...i, ...data } : i)) }
              : p
          ),
        })),
      removePersonalProjectItem: (projectId, itemId) =>
        set((s) => ({
          personalProjects: s.personalProjects.map((p) =>
            p.id === projectId
              ? { ...p, items: p.items.filter((i) => i.id !== itemId) }
              : p
          ),
        })),
      duplicatePersonalProject: (id) =>
        set((s) => {
          const proj = s.personalProjects.find((p) => p.id === id);
          if (!proj) return s;
          return {
            personalProjects: [
              ...s.personalProjects,
              {
                ...proj,
                id: crypto.randomUUID(),
                name: `${proj.name} (copia)`,
                status: 'active',
                items: proj.items.map((i) => ({ ...i, id: crypto.randomUUID(), completed: false })),
              },
            ],
          };
        }),

      // Agenda
      agendaItems: DEMO_AGENDA,
      addAgendaItem: (item) =>
        set((s) => ({
          agendaItems: [...s.agendaItems, { ...item, id: crypto.randomUUID(), paid: false, transactionId: null }],
        })),
      updateAgendaItem: (id, data) =>
        set((s) => ({
          agendaItems: s.agendaItems.map((a) => (a.id === id ? { ...a, ...data } : a)),
        })),
      removeAgendaItem: (id) =>
        set((s) => ({
          agendaItems: s.agendaItems.filter((a) => a.id !== id),
        })),
      markAgendaItemPaid: (id) =>
        set((s) => {
          const item = s.agendaItems.find((a) => a.id === id);
          if (!item || item.paid) return s;

          const txId = crypto.randomUUID();
          const newTx = {
            id: txId,
            description: item.title,
            amount: item.amount || 0,
            type: item.type,
            category: item.category,
            date: item.date,
          };

          let budgets = s.budgets;
          const newToasts = [];

          if (item.type === 'expense' && item.amount > 0) {
            budgets = budgets.map((b) => {
              if (b.category !== item.category) return b;
              const newSpent = b.spent + item.amount;
              const prevPct = (b.spent / b.limit) * 100;
              const newPct = (newSpent / b.limit) * 100;
              if (prevPct < 100 && newPct >= 100) {
                newToasts.push({ type: 'error', message: `budget.exceeded.${b.category}` });
              } else if (prevPct < 80 && newPct >= 80) {
                newToasts.push({ type: 'warning', message: `budget.warning.${b.category}` });
              }
              return { ...b, spent: newSpent };
            });
          }

          return {
            agendaItems: s.agendaItems.map((a) =>
              a.id === id ? { ...a, paid: true, transactionId: txId } : a
            ),
            transactions: [newTx, ...s.transactions],
            budgets,
            toasts: [...s.toasts, ...newToasts.map((t) => ({ ...t, id: crypto.randomUUID() }))],
          };
        }),
      duplicateAgendaItem: (id, targetMonth) =>
        set((s) => {
          const item = s.agendaItems.find((a) => a.id === id);
          if (!item) return s;
          const [y, m] = (targetMonth || currentMonth()).split('-').map(Number);
          const origDay = item.date.split('-')[2];
          const newDate = `${y}-${String(m).padStart(2, '0')}-${origDay}`;
          return {
            agendaItems: [
              ...s.agendaItems,
              { ...item, id: crypto.randomUUID(), date: newDate, paid: false, transactionId: null },
            ],
          };
        }),

      // Exchange rates
      exchangeRates: { rates: {}, lastFetchedAt: null, manualOverrides: {} },
      setExchangeRate: (from, to, rate) =>
        set((s) => ({
          exchangeRates: {
            ...s.exchangeRates,
            rates: { ...s.exchangeRates.rates, [`${from}_${to}`]: rate },
            lastFetchedAt: Date.now(),
          },
        })),
      setManualExchangeRate: (from, to, rate) =>
        set((s) => ({
          exchangeRates: {
            ...s.exchangeRates,
            manualOverrides: { ...s.exchangeRates.manualOverrides, [`${from}_${to}`]: rate },
          },
        })),
      clearManualExchangeRate: (from, to) =>
        set((s) => {
          const { [`${from}_${to}`]: _, ...rest } = s.exchangeRates.manualOverrides;
          return { exchangeRates: { ...s.exchangeRates, manualOverrides: rest } };
        }),
      registerExchange: ({ amount, rate, date, description, businessId, from, to }) =>
        set((s) => {
          const expenseId = crypto.randomUUID();
          const incomeId = crypto.randomUUID();
          const result = amount * rate;

          const expenseTx = {
            id: expenseId,
            description: `${description} (${from})`,
            amount,
            type: 'expense',
            category: 'other',
            date,
            businessId,
            exchangeRate: rate,
            exchangedFrom: from,
            linkedTo: incomeId,
          };

          const incomeTx = {
            id: incomeId,
            description: `${description} (${to})`,
            amount: result,
            type: 'income',
            category: 'other',
            date,
            exchangeRate: rate,
            exchangedFrom: from,
            linkedTo: expenseId,
          };

          return {
            transactions: [incomeTx, expenseTx, ...s.transactions],
          };
        }),

      // App settings
      appSettings: { chatEnabled: true, businessEnabled: true, propertiesEnabled: false },
      updateAppSettings: (data) =>
        set((s) => ({ appSettings: { ...s.appSettings, ...data } })),

      // Collaborators (not persisted, loaded on-demand)
      collaborators: [],
      loadedCollabFor: null,
      setCollaborators: (resourceKey, list) =>
        set(() => ({ collaborators: list, loadedCollabFor: resourceKey })),
      addCollaborator: (collab) =>
        set((s) => ({ collaborators: [...s.collaborators, collab] })),
      removeCollaborator: (id) =>
        set((s) => ({ collaborators: s.collaborators.filter((c) => c.id !== id) })),
      updateCollaboratorRole: (id, role) =>
        set((s) => ({
          collaborators: s.collaborators.map((c) => (c.id === id ? { ...c, role } : c)),
        })),

      // Toasts (not persisted)
      toasts: [],
      addToast: (toast) =>
        set((s) => ({
          toasts: [...s.toasts, { ...toast, id: crypto.randomUUID() }],
        })),
      removeToast: (id) =>
        set((s) => ({
          toasts: s.toasts.filter((t) => t.id !== id),
        })),

      // Clear all data (reset to demos)
      clearAllData: () =>
        set({
          user: DEMO_USER,
          transactions: DEMO_TRANSACTIONS,
          budgets: DEMO_BUDGETS,
          goals: DEMO_GOALS,
          splits: DEMO_SPLITS,
          banks: DEMO_BANKS,
          credits: DEMO_CREDITS,
          members: DEMO_MEMBERS,
          incomeUnits: DEMO_INCOME_UNITS,
          businesses: DEMO_BUSINESSES,
          projects: DEMO_PROJECTS,
          properties: DEMO_PROPERTIES,
          tenantExpenses: DEMO_TENANT_EXPENSES,
          personalProjects: DEMO_PERSONAL_PROJECTS,
          agendaItems: DEMO_AGENDA,
          exchangeRates: { rates: {}, lastFetchedAt: null, manualOverrides: {} },
        }),
    }),
    {
      name: 'kuadra2-storage',
      version: 15,
      migrate: (persistedState, version) => {
        const state = { ...persistedState };
        if (version < 8) {
          state.exchangeRates = state.exchangeRates || { rates: {}, lastFetchedAt: null, manualOverrides: {} };
        }
        if (version < 9) {
          if (state.appSettings.businessEnabled === undefined) {
            state.appSettings = { ...state.appSettings, businessEnabled: true };
          }
        }
        if (version < 10) {
          state.properties = state.properties || [];
          if (state.appSettings.propertiesEnabled === undefined) {
            state.appSettings = { ...state.appSettings, propertiesEnabled: false };
          }
        }
        if (version < 11) {
          state.tenantExpenses = state.tenantExpenses || [];
        }
        // v12: collaborators slice (not persisted, just ensure clean state)
        if (version < 13) {
          state.personalProjects = state.personalProjects || [];
        }
        if (version < 14) {
          state.properties = (state.properties || []).map((p) => ({
            ...p,
            status: p.status || (p.tenantName ? 'rented' : 'available'),
          }));
        }
        if (version < 15) {
          // Migrate memberId → memberIds for all entities
          const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
          const migrateField = (arr) =>
            (arr || []).map((item) => {
              if ('memberIds' in item) {
                return { ...item, memberIds: (item.memberIds || []).filter((id) => UUID_RE.test(id)) };
              }
              const { memberId, ...rest } = item;
              const ids = memberId && UUID_RE.test(memberId) ? [memberId] : [];
              return { ...rest, memberIds: ids };
            });
          state.transactions = migrateField(state.transactions);
          state.incomeUnits = migrateField(state.incomeUnits);
          state.banks = migrateField(state.banks);
          state.properties = migrateField(state.properties);
          // Add memberIds to entities that didn't have memberId before
          state.credits = (state.credits || []).map((c) => ({ ...c, memberIds: c.memberIds || [] }));
          state.goals = (state.goals || []).map((g) => ({ ...g, memberIds: g.memberIds || [] }));
          state.personalProjects = (state.personalProjects || []).map((p) => ({ ...p, memberIds: p.memberIds || [] }));
        }
        return state;
      },
      partialize: (state) => ({
        user: state.user,
        transactions: state.transactions,
        budgets: state.budgets,
        goals: state.goals,
        splits: state.splits,
        banks: state.banks,
        credits: state.credits,
        members: state.members,
        incomeUnits: state.incomeUnits,
        businesses: state.businesses,
        projects: state.projects,
        properties: state.properties,
        tenantExpenses: state.tenantExpenses,
        personalProjects: state.personalProjects,
        agendaItems: state.agendaItems,
        appSettings: state.appSettings,
        exchangeRates: state.exchangeRates,
      }),
    }
  )
);

// Helper selectors
export const selectUser = (state) => state.user;

export const selectBalance = (state) => {
  const income = state.transactions
    .filter((t) => t.type === 'income' && !t.businessId)
    .reduce((sum, t) => sum + t.amount, 0);
  const expenses = state.transactions
    .filter((t) => t.type === 'expense' && !t.businessId)
    .reduce((sum, t) => sum + t.amount, 0);
  return income - expenses;
};

export const selectTotalIncome = (state) =>
  state.transactions
    .filter((t) => t.type === 'income' && !t.businessId)
    .reduce((sum, t) => sum + t.amount, 0);

export const selectTotalExpenses = (state) =>
  state.transactions
    .filter((t) => t.type === 'expense' && !t.businessId)
    .reduce((sum, t) => sum + t.amount, 0);

export const selectByCategory = (state) => {
  const map = {};
  state.transactions
    .filter((t) => t.type === 'expense' && !t.businessId)
    .forEach((t) => {
      map[t.category] = (map[t.category] || 0) + t.amount;
    });
  return Object.entries(map)
    .map(([category, amount]) => ({ category, amount }))
    .sort((a, b) => b.amount - a.amount);
};

export const selectSplits = (state) => state.splits;

export const selectBanks = (state) => state.banks;
export const selectCredits = (state) => state.credits;
export const selectMembers = (state) => state.members;

export const selectCreditsByBank = (state) => {
  const grouped = {};
  state.banks.forEach((bank) => {
    grouped[bank.id] = {
      bank,
      credits: state.credits.filter((c) => c.bankId === bank.id),
    };
  });
  return grouped;
};

export const selectTotalMonthlyDebt = (state) =>
  state.credits
    .filter((c) => c.paidInstallments < c.totalInstallments)
    .reduce((sum, c) => sum + c.installmentAmount, 0);

export const selectLinkedPairs = (state) => {
  const seen = new Set();
  const pairs = [];
  for (const tx of state.transactions) {
    if (!tx.linkedTo || seen.has(tx.id)) continue;
    const partner = state.transactions.find((t) => t.id === tx.linkedTo);
    if (!partner) continue;
    // Skip exchange pairs — they have their own display
    if (tx.exchangedFrom || partner.exchangedFrom) continue;
    seen.add(tx.id);
    seen.add(partner.id);
    const income = tx.type === 'income' ? tx : partner;
    const expense = tx.type === 'expense' ? tx : partner;
    const coverage = income.amount > 0 ? Math.round((expense.amount / income.amount) * 100) : 0;
    pairs.push({ income, expense, coverage });
  }
  return pairs;
};

export const selectExchangeRate = (from, to) => (state) => {
  const key = `${from}_${to}`;
  return state.exchangeRates.manualOverrides[key] ?? state.exchangeRates.rates[key] ?? null;
};

export const selectIncomeUnits = (state) => state.incomeUnits;

export const selectIncomeUnitSummaries = (state) => {
  return state.incomeUnits.map((unit) => {
    const totalFixed = unit.fixedCosts.reduce((sum, c) => sum + c.amount, 0);
    const totalVariable = state.transactions
      .filter((t) => t.unitId === unit.id && t.category === 'unit_cost')
      .reduce((sum, t) => sum + t.amount, 0);
    const netIncome = unit.grossIncome - totalFixed - totalVariable;
    return { unit, totalFixed, totalVariable, netIncome };
  });
};

export const selectTotalNetIncome = (state) => {
  return state.incomeUnits.reduce((total, unit) => {
    const totalFixed = unit.fixedCosts.reduce((sum, c) => sum + c.amount, 0);
    const totalVariable = state.transactions
      .filter((t) => t.unitId === unit.id && t.category === 'unit_cost')
      .reduce((sum, t) => sum + t.amount, 0);
    return total + (unit.grossIncome - totalFixed - totalVariable);
  }, 0);
};

export const selectExpensesByMember = (state) => {
  const map = {};
  state.transactions
    .filter((t) => t.type === 'expense' && t.memberIds?.length > 0 && !t.businessId)
    .forEach((t) => {
      t.memberIds.forEach((id) => {
        map[id] = (map[id] || 0) + t.amount;
      });
    });
  return map;
};

export const selectBusinesses = (state) => state.businesses;

export const selectProjects = (state) => state.projects;

export const selectProjectsByBusiness = (businessId) => (state) =>
  state.projects.filter((p) => p.businessId === businessId);

export const selectProperties = (state) => state.properties;

export const selectPropertyById = (id) => (state) =>
  state.properties.find((p) => p.id === id);

export const selectPropertyTransactions = (propertyId) => (state) =>
  state.transactions.filter((t) => t.propertyId === propertyId);

export const selectTenantExpenses = (propertyId, month) => (state) =>
  state.tenantExpenses.filter((te) => te.propertyId === propertyId && te.month === month);

export const selectPersonalProjects = (state) => state.personalProjects;

export const selectPersonalProjectById = (id) => (state) =>
  state.personalProjects.find((p) => p.id === id);

export const selectPersonalProjectExpenses = (projectId) => (state) =>
  state.transactions.filter((t) => t.personalProjectId === projectId);

export const selectAgendaItems = (state) => state.agendaItems;

export const selectCollaborators = (state) => state.collaborators;
